import React from "react";

export default function HelpContent() {
    return (
        <div>
            For help, contact{" "}
            <a href="mailto:englishdept@uidaho.edu">englishdept@uidaho.edu</a>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/uofi/siteComponents/helpContent.js